class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if(window.location.pathname.search('/cart') > -1) {return}
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

function initEventCheckDiscount() {
  if(document.getElementById('apply_discount')) {
    document.getElementById('apply_discount').addEventListener('click', function (event) {
      event.preventDefault()
      const elmMessages =  document.getElementById('discount_message')
      const elmInput = document.getElementById('discount_code')
      const elmRemoveDiscount = document.getElementById('remove_discount')
      const discountCode = document.getElementById('discount_code').value
  
      if (discountCode) {
        elmInput.classList.remove('error')
        elmMessages.classList.remove('error')
        elmMessages.classList.remove('hidden')
  
        document.getElementById('discount_form_code').value = discountCode
  
        const formAction = `/discount/${discountCode}?redirect=/cart`
        document.getElementById('discount_form').action = formAction
  
        document.getElementById('discount_form').submit()
  
        elmMessages.innerText = window.translate.message_process_apply
  
        document.getElementById('discount_iframe').onload = function() {
          updateCartDetails()
        }
      } else {
        elmMessages.innerText = window.translate.field_required
        elmMessages.classList.remove('hidden')
        elmMessages.classList.add('error')
        elmInput.classList.add('error')
        elmRemoveDiscount.classList.add('hidden')
      }
    })
  }
  
  if(document.getElementById('remove_discount')) {
    document.getElementById('remove_discount').addEventListener('click', function (event) {
      event.preventDefault();
      const elmMessages =  document.getElementById('discount_message')
      const elmBtnSubmit = document.getElementById('apply_discount')
      const elmInput = document.getElementById('discount_code')
    
      document.getElementById('discount_form_code').value = ''
      const formAction = `/discount/null/?redirect=/cart`
      document.getElementById('discount_form').action = formAction
    
      document.getElementById('discount_form').submit()
      elmMessages.innerText = window.translate.message_process_remove
    
      document.getElementById('discount_iframe').onload = function() {
        updateCartDetails()
        elmMessages.innerText = window.translate.message_remove_success
        document.getElementById('remove_discount').classList.add('hidden')
    
        setTimeout(() => {
          elmMessages.classList.add('hidden')
        }, 2000)
  
        elmInput.value = ''
        elmBtnSubmit.removeAttribute('disabled')
      }
    })
  }
}

function updateCartDetails() {
  const elmMessages =  document.getElementById('discount_message')
  const elmRemoveDiscount = document.getElementById('remove_discount')
  const elmBtnSubmit = document.getElementById('apply_discount')
  
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if(cart.total_discount > 0) {
        // Discount valid
        elmMessages.innerText = window.translate.message_apply_success
        elmRemoveDiscount.classList.remove('hidden')

        elmBtnSubmit.setAttribute('disabled', true)

      } else {
        // Discount invalid
        elmMessages.innerText = window.translate.message_discount_invalid
        elmRemoveDiscount.classList.add('hidden')
      }

      setTimeout(() => {
        elmMessages.classList.add('hidden')
      }, 2000)

      refreshCartDrawer()
    })
    .catch(error => console.error('Error fetching cart details:', error));
}

async function refreshCartDrawer() {
  await fetch(`${routes.cart_url}`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const drawerJsContents = document.querySelector('.drawer__footer .cart-drawer__footer')
      drawerJsContents.innerHTML = html.querySelector('.cart__footer .js-contents').innerHTML
    })
    .catch((e) => {
      console.error(e);
    });
}

const cartDrawer = document.querySelector('.cart-drawer')
if (cartDrawer) {
  const observer = new MutationObserver(() => {
    initEventCheckDiscount()
  })

  observer.observe(cartDrawer, { childList: true, subtree: true });
}

